import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback } from '../../../redux/reducers/authSlice';
import { CompanyService } from '../../../services/CompanyService';
import { GetCompanyListPagingAndFilterRequest, initialGetCompanyListPagingAndFilterRequest } from '../../../models/request/company/GetCompanyListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetCompanyListPagingAndFilterResponse, GetCompanyListPagingAndFilterResponseData, GetCompanyListPagingAndFilterResponseItem, initialGetCompanyListPagingAndFilterResponseData } from '../../../models/response/company/GetCompanyListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { DeleteCompanyResponse } from '../../../models/response/company/DeleteCompanyResponse';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import CompanyListFilters from './Components/CompanyListFilters';
import { ExportCompanyListResponse } from '../../../models/response/company/ExportCompanyListResponse';
import { ConstantService } from '../../../services/ConstantService';
import { GetConstantListResponse } from '../../../models/response/constant/GetConstantListResponse';
import { MeetingCompanyTypeEnum } from '../../../models/common/Enums';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions, ColumnFilterOption } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';

const CompanyList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Ön Muhasebe > Tanımlamalar > Firma Tanımları"
    const pageVersion = "1";
    const [data, setData] = useState<GetCompanyListPagingAndFilterResponseData>(initialGetCompanyListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetCompanyListPagingAndFilterRequest>(initialGetCompanyListPagingAndFilterRequest);
    const [isFirstTime, setIsFirstTime] = useState(true);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Kısa Ad', name: 'name', order: 0, isVisible: true },
            { title: 'Fatura Ünvanı', name: 'longName', order: 0, isVisible: true },
            { title: 'Telefon 1', name: 'phone1', order: 0, isVisible: true },
            { title: 'E-Posta', name: 'email', order: 0, isVisible: true },
            { title: 'Firma Türü', name: 'companyTypeName', order: 0, isVisible: true },
            { title: 'Ticari Türü', name: 'commercialTypeName', order: 0, isVisible: true },
            { title: 'Vergi Dairesi', name: 'taxOffice', order: 0, isVisible: true },
            { title: 'Vergi Kimlik No', name: 'vkn', order: 0, isVisible: true },
            { title: 'Firma Durumu', name: 'initialCompanyTypeName', order: 0, isVisible: true },
            { title: 'Açıklama', name: 'description', order: 0, isVisible: true },
            { title: 'B2C Firma', name: 'isB2c', order: 0, isVisible: true },
            { title: 'TC Kimlik No', name: 'tckn', order: 0, isVisible: true },
            { title: 'Aktif', name: 'isCustomActive', order: 0, isVisible: true },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteCompany = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.companyId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteCompanyResponse = await CompanyService.deleteCompany(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateCompany = async (_id: string | undefined = undefined) => {
        navigate('/company/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].companyId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetCompanyListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            dispatch(storeActivityIndicator(true))

            if (isFirstTime) {
                // Açılışta eski filtre panelindeki varsayılan kolon filtresi olarak kurulur:
                // firma durumu "Çalışılan Müşteri" (AdditionalValue1 = "3").
                var defaultColumnFilters: ColumnFilterModel[] = [];

                var response5: GetConstantListResponse = await ConstantService.getConstantList('MEETING_COMPANY_TYPE', undefined, MeetingCompanyTypeEnum.CALISILAN_MUSTERI);

                if (!response5.isSuccess) {
                    toast.error(response5.message)
                    return;
                }

                if (response5.data.length > 0)
                    defaultColumnFilters.push({ column: 'initialCompanyTypeName', values: [response5.data[0].constantId], valueLabels: [response5.data[0].value + ''] });

                if (!_filter)
                    _filter = { ...filter, columnFilters: defaultColumnFilters };

                setIsFirstTime(false);
            }

            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            var response: GetCompanyListPagingAndFilterResponse = await CompanyService.getCompanyListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.companyId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportCompanyListResponse = await CompanyService.exportCompanyList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.companyId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Hesaplanan kolonlar (firma türü
    // gibi bayraklardan üretilenler) ve oluşturan/güncelleyen bilgisi listede yok.
    const sortableColumns = [
        'name', 'longName', 'phone1', 'email',
        'commercialTypeName', 'taxOffice', 'vkn', 'tckn',
        'initialCompanyTypeName', 'description',
        'isB2c', 'isCustomActive'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Firma türü seçenekleri: firmadaki işaretlere (Müşteri, Tedarikçi…) karşılık gelir.
    // Etiketler listedeki birleştirilmiş metinle (CompanyController) aynı.
    const companyTypeOptions = (): Promise<ColumnFilterOption[]> => Promise.resolve([
        { value: 'isCustomer', label: 'Müşteri' },
        { value: 'isSupplier', label: 'Tedarikçi' },
        { value: 'isAgency', label: 'Acente' },
        { value: 'isSenderFirm', label: 'Gönderici Firma' },
        { value: 'isReceiverFirm', label: 'Alıcı Firma' },
        { value: 'isDutyFirm', label: 'Gümrük Firması' },
        { value: 'isAirlineFirm', label: 'Havayolu' },
        { value: 'isSeawayFirm', label: 'Denizyolu' },
        { value: 'isCompany', label: 'Şirket' },
        { value: 'isRepresentative', label: 'Mümessil' },
        { value: 'isInsuranceFirm', label: 'Sigorta Firması' },
    ]);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (CompanyManager.ApplyColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        name: { type: 'text' },
        longName: { type: 'text' },
        phone1: { type: 'text' },
        email: { type: 'text' },
        // Seçilen türlerden herhangi biri işaretli firmalar gelir.
        companyTypeName: { type: 'select', allowEmpty: false, loadOptions: companyTypeOptions },
        commercialTypeName: { type: 'select', loadOptions: () => loadConstants('COMPANY_COMMERCIAL_TYPE') },
        taxOffice: { type: 'text' },
        vkn: { type: 'text' },
        initialCompanyTypeName: { type: 'select', loadOptions: () => loadConstants('MEETING_COMPANY_TYPE'), renderOption: (label) => <StatusBadge text={label} /> },
        description: { type: 'text' },
        isB2c: YES_NO_FILTER,
        tckn: { type: 'text' },
        isCustomActive: YES_NO_FILTER,
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetCompanyListPagingAndFilterResponseItem, column: string, index: number) => {
        if (column == "isCustomActive") {
            return (
                <td onClick={() => setItemSelected(item.companyId)} onDoubleClick={() => updateCompany(item.companyId)}><StatusBadge text={item.isCustomActive ? "Evet" : "Hayır"} /></td>
            )
        }
        else if (column == "initialCompanyTypeName") {
            return (
                <td onClick={() => setItemSelected(item.companyId)} onDoubleClick={() => updateCompany(item.companyId)}><StatusBadge text={item.initialCompanyTypeName} /></td>
            )
        }
        else if (column == "isB2c") {
            return (
                <td onClick={() => setItemSelected(item.companyId)} onDoubleClick={() => updateCompany(item.companyId)}>{item.isB2c ? "Evet" : "Hayır"}</td>
            )
        }
        else if (column == "createdUser") {
            return (
                <td onClick={() => setItemSelected(item.companyId)} onDoubleClick={() => updateCompany(item.companyId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td onClick={() => setItemSelected(item.companyId)} onDoubleClick={() => updateCompany(item.companyId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else {
            var item2: any = item;
            return <td onClick={() => setItemSelected(item.companyId)} onDoubleClick={() => updateCompany(item.companyId)}>{item2[column]}</td>;
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <CompanyListFilters
                    columns={columns}
                    excelExport={excelExport}
                    filter={filter}
                    getColumns={getColumns}
                    getData={getData}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteCompany}
                    updateFunction={updateCompany}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.companyId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default CompanyList;